import React, { useEffect, useState } from 'react';
// Styled Components:
import Box from '@material-ui/core/Box';
import { Tooltip, Modal } from 'antd';
import classNames from 'classnames';
import { useStyles } from './CotplayHubVideoContainerStyles';
import './CotplayHubVideoStyles.css';
import * as CotplayHubActions from '../../../actions/CotplayHubActions';
import { useDispatch, useSelector } from 'react-redux';
import convertBase64toBlob from 'app/utils/ConvertBase64ToBlob';
import './CotplayHubVideoStyles.css';
import MediaPlayer from 'app/components/MediaPlayer';

export const CotplayHubVideo = (props) => {

    // Generals:
    const { confirm } = Modal;
    let [player] = useState();
    const classes = useStyles();
    const videoNode = React.createRef()
    const onBoard = process.env.REACT_APP_ON_BOARD_URL;
    let [timeWatched, setTimeWatched] = useState(null);
    let [data, setData] = useState(props.data);

    const [playerVideoHub, setplayerVideoHub] = useState({
		urlStream: '',
		dashStream: '',
		hlsStream: '',
        timeVideo: 0
	});

    const dispatch = useDispatch();

    const {
        employeeId
    } = useSelector(state => state.Auth.employeeById);

    // Effects:
    useEffect(() => {
        setVideo();
    }, []
    )
    // Functions:
    const setVideo = () => {
        
        if (playerVideoHub.urlStream === '') {     
			setplayerVideoHub({
                urlStream: props.data.video,
                hlsStream: props.data.hls,
                dashStream: props.data.dash,
                timeVideo: props.data.timeVideo,
                thumbnail: props.data.thumbnail
            });
		}        

    }





    // Overlay Screen Function: 

    // document.addEventListener('visibilitychange', () => {
    //     document.title = document.visibilityState;
    // });

    return (
        <Box className={classes.videoBox}>
            <div className={classes.azuremediaplayerDiv}>

                { playerVideoHub.urlStream === '' ? <div /> : <MediaPlayer videoData={playerVideoHub} idCourse={props.data.idCourse}
                            employeeId={employeeId} idMultimedia={props.data.idMultimedia} parent={"CotPlayHub"}></MediaPlayer> }
                <div className={classes.DescriptionBox}>

                    <h5 className='VideoDescriptionLine'>
                        <Tooltip title={props.data.courseName}>
                            <i className={classes.VideoDescription}>Procedimiento:  </i>
                            {props.data.courseName}
                        </Tooltip>
                    </h5>

                    <h5 className='VideoDescriptionLine'>
                        <Tooltip title={props.data.trainingName}>
                            <i className={classes.VideoDescription}>Tipo de Capacitación:  </i>
                            {props.data.trainingName}
                        </Tooltip>
                    </h5>

                    <h5 className='VideoDescriptionLine'>
                        <Tooltip title={props.data.specialtyName + ' / ' + props.data.categoryName}>
                            <i className={classes.VideoDescription}>Especialidad/Sistema/Categoría:  </i>
                            {props.data.specialtyName + ' / ' + props.data.categoryName}
                        </Tooltip>
                    </h5>

                    <h5 className='VideoDescriptionLine'>
                        <Tooltip title={props.data.subdirectionName}>
                            <i className={classes.VideoDescription}>Subdirección Origen:  </i>
                            {props.data.subdirectionName}
                        </Tooltip>
                    </h5>

                    <section className={classes.VideoDurationBox}>
                        <div
                            className={classes.CounterBox}
                            style={{ marginRight: '2.5px' }}
                        >
                            <h5 className={classes.VideoDescriptionCounter}>
                                <Tooltip title={props.data.videoDuration}>
                                    <i
                                        className={classes.VideoDescriptionFooter}
                                    >
                                        Duración:
                                    </i>
                                    {props.data.videoDuration}
                                </Tooltip>
                            </h5>
                        </div>

                        <div
                            className={classes.CounterBox}
                            style={{ marginLeft: '2.5px' }}
                        >
                            <h5 className={classes.VideoDescriptionCounter}>
                                <Tooltip title={props.data.replays}>
                                    <i
                                        className={classes.VideoDescriptionFooter}
                                    >
                                        Vistas:
                                    </i>
                                    {props.data.replays}
                                </Tooltip>
                            </h5>
                        </div>

                    </section>

                </div>

            </div>
        </Box>
    )
}
